// Screens Baraa can open by voice/text command.
export const NAV_TARGETS = {
  opcards: { label: "كروت التشغيل", dialog: "opcards", words: ["كروت التشغيل", "كرت التشغيل", "بطاقات التشغيل", "بطاقه التشغيل", "كروت", "operating card"] },
  "add-employee": { label: "إضافة موظف", dialog: "add-employee", words: ["اضافه موظف", "موظف جديد", "اضف موظف"] },
  report: { label: "التقارير المخصصة", dialog: "report", words: ["تقرير مخصص"] },
  import: { label: "استيراد الموظفين", dialog: "import", words: ["استيراد"] },
  finance: { label: "برنامج WorkZone المحاسبي", path: "/finance", words: ["المحاسبه", "المحاسبي", "القيود", "الحسابات"] },
  fuel: { label: "الوقود", view: "fuel", words: ["الوقود", "وقود", "واعي", "الدريس", "البنزين"] },
  employees: { label: "الموظفين", view: "employees", words: ["الموظفين", "الموظفون", "الموظف"] },
  "riders-distances": { label: "مسافات المناديب", view: "riders-distances", words: ["المسافات", "مسافات"] },
  "riders-rented": { label: "الحسابات المستأجرة", view: "riders-rented", words: ["المستأجرة", "فري لانسر", "الحسابات المستأجرة"] },
  "riders-daily": { label: "الأداء اليومي للمناديب", view: "riders-daily", words: ["الاداء اليومي", "اليومي"] },
  "riders-compare": { label: "مقارنة التطبيقات", view: "riders-compare", words: ["مقارنه التطبيقات", "التطبيقات"] },
  "riders-target": { label: "مستهدف المناديب", view: "riders-target", words: ["المستهدف", "التارجت"] },
  riders: { label: "المناديب", view: "riders", words: ["المناديب", "المندوبين", "الطلبات", "مناديب"] },
  vehicles: { label: "المركبات", view: "vehicles", words: ["المركبات", "السيارات", "الدبابات", "الدراجات", "مركبات"] },
  custody: { label: "العُهد", view: "custody", words: ["العهد", "العهده", "عهد"] },
  salaries: { label: "الرواتب", view: "salaries", words: ["الرواتب", "رواتب", "مسير"] },
  advances: { label: "السلف", view: "advances", words: ["السلف", "سلف", "سلفه"] },
  violations: { label: "المخالفات", view: "violations", words: ["المخالفات", "مخالفات"] },
  attendance: { label: "الحضور", view: "attendance", words: ["الحضور", "الدوام", "البصمه"] },
  leave: { label: "الإجازات", view: "leave", words: ["الاجازات", "اجازات", "الاجازه"] },
  tasks: { label: "المهام", view: "tasks", words: ["المهام", "مهام"] },
  wallets: { label: "المحافظ", view: "wallets", words: ["المحافظ", "محافظ"] },
  revenues: { label: "الإيرادات", view: "revenues", words: ["الايرادات", "ايرادات"] },
  "reports-hub": { label: "مركز التقارير", view: "reports-hub", words: ["التقارير", "مركز التقارير"] },
  "car-maintenance": { label: "صيانة السيارات", view: "car-maintenance", words: ["صيانه السيارات"] },
  "moto-maintenance": { label: "صيانة الدراجات", view: "moto-maintenance", words: ["صيانه الدراجات", "صيانه الدبابات"] },
  spareparts: { label: "قطع الغيار", view: "spareparts", words: ["قطع الغيار"] },
  branches: { label: "الفروع", view: "branches", words: ["الفروع", "فروع"] },
  analytics: { label: "التحليلات", view: "analytics", words: ["التحليلات", "تحليلات"] },
  correspondence: { label: "المراسلات", view: "correspondence", words: ["المراسلات", "الخطابات"] },
  injuries: { label: "الإصابات", view: "injuries", words: ["الاصابات"] },
  purchases: { label: "المشتريات", view: "purchases", words: ["المشتريات"] },
  alerts: { label: "التنبيهات", view: "alerts", words: ["التنبيهات"] },
  "rider-cards": { label: "بطاقة المندوب", view: "rider-cards", words: ["بطاقه المندوب", "بطاقات المناديب", "البطاقات"] },
  decisions: { label: "القرارات الإدارية", view: "decisions", words: ["القرارات", "قرار اداري", "القرارات الاداريه"] },
  library: { label: "مكتبة الشركة", view: "library", words: ["المكتبه", "مكتبه الشركه"] },
  contracts: { label: "إدارة العقود", view: "contracts", words: ["العقود", "عقد", "صياغة عقد"] },
  "private-docs": { label: "الوثائق الخاصة", view: "private-docs", words: ["الوثائق الخاصه", "وثائق خاصه", "الخزنه"] },
  outlook: { label: "بريد Outlook", view: "outlook", words: ["اوتلوك", "الاوت لوك", "outlook", "ارسال ايميل", "الايميل"] },
  "saudi-files": { label: "ملفات الموظفين السعوديين", view: "saudi-files", words: ["السعوديين", "السعوده", "ملفات السعوديين"] },
  overview: { label: "الرئيسية", view: "overview", words: ["الرئيسيه", "الصفحه الرئيسيه", "الداشبورد"] },
};

const norm = (s = "") => s.toLowerCase()
  .replace(/[\u064B-\u0652\u0640]/g, "")
  .replace(/[أإآ]/g, "ا").replace(/ة/g, "ه").replace(/ى/g, "ي")
  .replace(/\s+/g, " ").trim();

const VERB_RE = /(^|\s)(افتح|افتحي|افتحلي|افتح لي|فتح|اعرض|اعرضلي|وريني|ورني|خذني|ودني|ودّني|روح|انتقل|اذهب|ابي|ابغى|ابغي|اريد|open|go to|show)(\s|$)/;
const QUESTION_RE = /(كيف|ليش|لماذا|ما هو|ما هي|وش|ايش|متى|هل)/;

// Fast local match: an "open" verb + a known screen keyword (longest keyword wins).
export const matchCommand = (text) => {
  const t = norm(text);
  if (!VERB_RE.test(t) || QUESTION_RE.test(t) || t.length > 60) return null;
  let best = null;
  Object.entries(NAV_TARGETS).forEach(([key, v]) => v.words.forEach((w) => {
    const nw = norm(w);
    if (t.includes(nw) && (!best || nw.length > best.len)) best = { key, len: nw.length };
  }));
  return best?.key || null;
};

const OPEN_RE = /\[\[open:([^\]]+)\]\]/;
export const splitOpen = (text = "") => {
  const m = text.match(OPEN_RE);
  const key = m ? m[1].trim() : null;
  return { text: text.replace(/\[\[open:[^\]]*\]\]/g, "").trim(), open: key && NAV_TARGETS[key] ? key : null };
};

// Opens the target; dashboard targets are queued if the dashboard isn't mounted yet.
export const openTarget = (key, navigate) => {
  const tg = NAV_TARGETS[key];
  if (!tg) return false;
  if (tg.path) { navigate(tg.path); return true; }
  const detail = { key, view: tg.view, dialog: tg.dialog };
  if (window.__wzDashReady) window.dispatchEvent(new CustomEvent("baraa:open", { detail }));
  else { window.__baraaPending = detail; navigate("/"); }
  return true;
};

export const navCatalog = () => Object.entries(NAV_TARGETS).map(([id, v]) => ({ id, label: v.label }));
